module.exports = "/_next/static/images/e595befd762f58279cba1c0648e08bea-girl-holding-phone@0.5x.jpg";